import DeviceAlertsRoute from 'garaje/pods/visitors/devices/alerts/route';

export default class VirtualFrontDeskDeviceAlertsRoute extends DeviceAlertsRoute {
  controllerName = 'visitors/devices/alerts';
  templateName = 'visitors/devices/alerts';
}
